import React from 'react';
import './link-button.css';
import {Link} from "react-router-dom";

export function LinkButton({ text, to, className, disabled }) {

    return (
        <Link to={to}>
            <button
                className={`link-button pointer b2-m ${className || ''}`}
                disabled={disabled}>
                {text}
            </button>
        </Link>
    );
}